import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        documentTypes: false
      },
      options: {
        documentTypes: []
      },
      selected: {
        role: '',
        documentType: '',
        documentCategory: 'Grower'
      },
      editable: {
        documentType: ''
      }
    }
  },

  methods: {

    async getDocumentTypes (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.documentType
      const selectedDocumentCategory = context.selected?.documentCategory
      const selectedRole = context.selected?.role
      const fetching = context.fetching?.documentTypes
      const options = context.options?.documentTypes

      const hasInvalidContext = [
        nullOrUndefined(selected),
        nullOrUndefined(fetching),
        nullOrUndefined(options),
        nullOrUndefined(selectedDocumentCategory),
        nullOrUndefined(selectedRole)
      ].some(isTrue => isTrue)

      if (hasInvalidContext) {
        throw Error('Invalid context object')
      }

      context.fetching.documentTypes = true
      context.selected.documentType = ''

      const filters = {
        filter_text: search,
        document_type_category: context.selected?.documentCategory || '',
        role_id: context.selected?.role || ''
      }

      return await SSharedList.getDocumentTypes(filters).then(
        ({ data }) => {
          context.options.documentTypes = data
        }
      ).catch(() => {
        context.options.documentTypes = []
      }).finally(() => {
        context.fetching.documentTypes = false
      })
    },

    async searchDocumentTypes (search, loading) {
      this.searchDocumentTypesProvider(this, search, loading)
    },

    searchDocumentTypesProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.documentTypes, {
          keys: ['document_type_name', 'name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            document_type_category: selected?.documentCategory || '',
            role_id: selected?.role || ''
          }

          SSharedList.getDocumentTypes(filters).then(
            ({ data }) => {
              options.documentTypes = data
            }
          ).catch(() => {
            options.documentTypes = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
